// extracted by mini-css-extract-plugin
export var aboveInput = "_h5-0";
export var actionButton = "_h5-5";
export var actionButtonContainer = "_h5-1";
export var actionIcon = "_h5-6";
export var aiInfoContainer = "_h5-2";
export var attachmentWrapper = "_h5-7";
export var bold = "_h5-3";
export var checkIcon = "_h5-8";
export var clickingRecipientBar = "_h5-11";
export var commentThreadSwitch = "_h5-a";
export var draftImage = "_h5-b";
export var draftImageContainer = "_h5-c";
export var draftImages = "_h5-e";
export var editButton = "_h5-g";
export var editor = "_h5-f";
export var editorContainer = "_h5-y";
export var editorErrorTooltipWrapper = "_h5-9";
export var headerDivider = "_h5-h";
export var icon = "_h5-i";
export var info = "_h5-j";
export var internal = "_h5-n";
export var internalDivider = "_h5-k";
export var internalMessage = "_h5-l";
export var messageInputCard = "_h5-m";
export var messageInputForm = "_h5-o";
export var messageInputFormInternal = "_h5-p";
export var options = "_h5-q";
export var publicMessageCustomer = "_h5-s";
export var publicMessageMerchant = "_h5-r";
export var removeImageButton = "_h5-d";
export var replyButtons = "_h5-t";
export var showSignatureButton = "_h5-u";
export var spinner = "_h5-v";
export var verticalButtonDivider = "_h5-4";
export var visibilitySelector = "_h5-w";
export var warning = "_h5-x";
export var wrappingText = "_h5-z";
export var writingInternalNoteTopBorder = "_h5-10";